import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'tlp-submit-button',
  templateUrl: './submit-button.component.html',
  styleUrls: ['./submit-button.component.css']
})
export class SubmitButtonComponent {
  
  @Input() isProcessing: boolean | null = false;
  @Input() disabled: boolean | null = false; // Input to control disabled state from parent
  @Input() label: string = 'Save'
  @Output() clicked = new EventEmitter<void>(); // Output to signal clicks to the parent

  constructor() { }

  // Method called when the internal button's native click event fires
  onButtonClick() {
    // It's good practice to check disabled state before emitting,
    // although the native [disabled] should prevent the click anyway.
    if (!this.disabled) {
      this.clicked.emit(); // Emit the custom 'clicked' event
    }
  }
}